import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { quotePageState } from "../../../atoms/quote/quote-page-state";
import { quoteService } from "../../../services/quote-service";
import { CustomCell } from "../CustomCell";
import { PartnerDetailQuoteFooter } from "./PartnerDetailQuoteFooter";
import { PartnerDetailQuoteRow } from "./PartnerDetailQuoteRow";

const headers: TableHeader[] = [
  { title: "No", width: "w-[52px]" },
  { title: "견적", width: "w-[912px]" },
  { title: "견적 금액", width: "w-[160px]" },
  { title: "고객명", width: "w-[160px]" },
  { title: "공사명", width: "w-[240px]" },
  { title: "견적 날짜", width: "w-[120px]" },
];

interface Props {
  partnerId: number;
}

export const PartnerDetailQuoteTable: React.FC<Props> = ({ partnerId }) => {
  // const page = useRecoilValue(partnerProductOrderItemPageState);

  const [page, setPage] = useRecoilState(quotePageState);

  const items = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_5;

  const getPage = async () => {
    const response = await quoteService.getPagePartner(partnerId, {
      page: page.currentPage,
      size: PaginationSize.SIZE_5,
    });
    setPage(response.data);
  };

  useEffect(() => {
    getPage();
  }, [page.currentPage]);

  return (
    <div className="w-full overflow-x-auto rounded-lg border">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item, index) => (
            <PartnerDetailQuoteRow
              key={item.id}
              data={item}
              index={index}
              startIndex={startIndex}
            />
          ))}
          <PartnerDetailQuoteFooter
            headersLength={Object.values(headers).length + 2}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
